<script setup>

const { resources, labels } = window.DATAGENT_PLUGIN_CHAT;

</script>

<template>
    <div v-if="resources" class="da:grid da:grid-cols-1 sm:da:grid-cols-2 md:da:grid-cols-3 da:gap-4 da:justify-items-start">
      <!-- Resource Cards -->
      <div
        v-for="(resource, resourceId) in resources"
        :key="resourceId"
        class="da:border-2 da:border-[#eee] da:rounded-md da:p-4 da:m-2 da:bg-[#fafafa] da:transition-all da:duration-300 da:ease-in-out da:hover:shadow-md da:max-w-md"
      >
        <div class="da:flex da:items-start da:justify-between">
          <div class="da:flex-1">
            <div class="da:flex da:items-center">
              <div
                class="da:w-12 da:h-12 da:flex da:items-center da:justify-center da:bg-[#f0f0f0] da:rounded-full da:overflow-hidden da:mr-2"
              >
                <img v-if="resource.image" :src="resource.image.url" :alt="resource.image.alt" class="da:w-full da:h-full da:object-cover" />
                <i v-else :class="resource.icon" class="da:text-xl"></i>
              </div>
              <h3 class="da:text-base da:font-medium da:mb-1">
                {{ resource.name }}
                <a v-if="resource.link" :href="resource.link" class="da:text-blue-500 da:underline">
                    #{{ resource.id }}
                </a>
            </h3>
            </div>

            <p class="da:text-sm da:text-gray-600 da:mb-3">{{ resource.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="da:p-4">
        {{ labels.no_resources }}
    </div>
</template>